var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { supabase } from '@/lib/supabase';
// ─── Fetch ───────────────────────────────────────────────────────────────
export var fetchSubscription = function () { return __awaiter(void 0, void 0, void 0, function () {
    var user, _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabase.auth.getUser()];
            case 1:
                user = (_b.sent()).data.user;
                if (!user)
                    return [2 /*return*/, null];
                return [4 /*yield*/, supabase
                        .from('subscriptions')
                        .select('*')
                        .eq('user_id', user.id)
                        .single()];
            case 2:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error || !data)
                    return [2 /*return*/, null];
                return [2 /*return*/, data];
        }
    });
}); };
// ─── Can create client? ──────────────────────────────────────────────────
export var canCreateClient = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabase.rpc('can_create_client')];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    console.error('can_create_client error:', error);
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, !!data];
        }
    });
}); };
// ─── Stripe Checkout ─────────────────────────────────────────────────────
var SUPABASE_URL = 'https://cemtccfulgwewdptkukt.supabase.co';
export var createCheckoutSession = function () { return __awaiter(void 0, void 0, void 0, function () {
    var session, res, errText, url, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.auth.getSession()];
            case 1:
                session = (_a.sent()).data.session;
                if (!session)
                    return [2 /*return*/, null];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 7, , 8]);
                return [4 /*yield*/, fetch("".concat(SUPABASE_URL, "/functions/v1/stripe-checkout"), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer ".concat(session.access_token),
                        },
                        body: JSON.stringify({
                            returnUrl: window.location.origin,
                        }),
                    })];
            case 3:
                res = _a.sent();
                if (!!res.ok) return [3 /*break*/, 5];
                return [4 /*yield*/, res.text()];
            case 4:
                errText = _a.sent();
                console.error('Checkout error:', errText);
                return [2 /*return*/, null];
            case 5: return [4 /*yield*/, res.json()];
            case 6:
                url = (_a.sent()).url;
                return [2 /*return*/, url];
            case 7:
                err_1 = _a.sent();
                console.error('Failed to create checkout session:', err_1);
                return [2 /*return*/, null];
            case 8: return [2 /*return*/];
        }
    });
}); };
// ─── Customer Portal (manage subscription) ───────────────────────────────
export var createPortalSession = function () { return __awaiter(void 0, void 0, void 0, function () {
    var session, res, url, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.auth.getSession()];
            case 1:
                session = (_a.sent()).data.session;
                if (!session)
                    return [2 /*return*/, null];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 6]);
                return [4 /*yield*/, fetch("".concat(SUPABASE_URL, "/functions/v1/stripe-portal"), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer ".concat(session.access_token),
                        },
                        body: JSON.stringify({
                            returnUrl: window.location.origin,
                        }),
                    })];
            case 3:
                res = _a.sent();
                if (!res.ok)
                    return [2 /*return*/, null];
                return [4 /*yield*/, res.json()];
            case 4:
                url = (_a.sent()).url;
                return [2 /*return*/, url];
            case 5:
                err_2 = _a.sent();
                console.error('Failed to create portal session:', err_2);
                return [2 /*return*/, null];
            case 6: return [2 /*return*/];
        }
    });
}); };
